import React, { Component } from 'react'
import Parser from 'html-react-parser'
import PropTypes from 'prop-types'

import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'
import Checkbox from '@ynap/checkbox'

const bem = new BEMHelper('MarketingPreferences')

export class ConsentCheckbox extends Component {
    static layoutVariant = 'consent-checkbox'

    static propTypes = {
        item: PropTypes.objectOf({
            ID: PropTypes.string,
        }),
        form: PropTypes.array,
        handleCheck: PropTypes.func,
    }

    render() {
        const { item, form, modifier } = this.props
        const { ID: id } = item

        const checked = form[id] === true
        const isMarketingConsent = !modifier && id === 'maMarketingConsent'

        return (
            <Checkbox
                className={bem('consent-item-checkbox', [isMarketingConsent ? 'marketingConsent' : '', modifier])}
                type="checkbox"
                checked={checked}
                onChange={() => this.props.handleCheck(id, !checked)}
                id={id}
            />
        )
    }
}

export class ConsentOptedIn extends Component {
    static layoutVariant = 'consent-opted-in'

    static propTypes = {
        item: PropTypes.objectOf({
            teaserTitle: PropTypes.string,
        }),
        children: PropTypes.any,
    }

    render() {
        const { item, children } = this.props

        return (
            <div className={bem('consent-item')}>
                {item.teaserTitle ? (
                    <div className={bem('consent-item-title-line')}>
                        <h4 className={bem('consent-item-title')}>{item.teaserTitle}</h4>
                    </div>
                ) : null}
                {children ? children : null}
            </div>
        )
    }
}

export class ConsentPreference extends Component {
    static layoutVariant = 'consent-preference'

    static propTypes = {
        item: PropTypes.objectOf({
            teaserTitle: PropTypes.string,
        }),
        children: PropTypes.any,
        hidden: PropTypes.bool,
    }

    render() {
        const { item, children, hidden, tags, modifier, withLabel } = this.props

        const consentPeferenceId = children?.[0]?.props.item.ID
        const isLoyaltyItem = !!tags?.some((tag) => tag.name === 'loyalty')

        return hidden ? null : (
            <div className={bem('consent-item', [isLoyaltyItem ? 'loyalty' : '', modifier])}>
                {item.teaserTitle && !isLoyaltyItem ? (
                    <div className={bem('consent-item-title-line', modifier)}>
                        {withLabel ? (
                            <label htmlFor={consentPeferenceId} className={bem('consent-item-title', modifier)}>
                                {item.teaserTitle}
                            </label>
                        ) : (
                            <h4 className={bem('consent-item-title', modifier)}>{item.teaserTitle}</h4>
                        )}
                    </div>
                ) : null}
                {children ? children : null}
            </div>
        )
    }
}

export class ConsentItem extends Component {
    static layoutVariant = 'consent-item'

    static propTypes = {
        item: PropTypes.objectOf({
            teaserTitle: PropTypes.string,
            teaserText: PropTypes.string,
        }),
        children: PropTypes.any,
    }

    render() {
        const { item, children, tags, parent } = this.props
        const { teaserText, subTitlePlain, preTitlePlain } = item

        const consentPeferenceId = parent?.items?.find((item) => (item.type = 'placeholder'))?.ID
        const isLoyaltyItem = !!tags?.some((tag) => tag.name === 'loyalty')

        return (
            <div className={bem('consent-item-detail')}>
                {!isLoyaltyItem && !!subTitlePlain?.length && (
                    <h5 className={bem('consent-item-detail-subtitle')}>{subTitlePlain}</h5>
                )}
                {isLoyaltyItem && !!parent?.teaserTitle?.length && (
                    <label
                        htmlFor={consentPeferenceId}
                        className={bem('consent-item-detail-subtitle', isLoyaltyItem ? 'hasCheckbox' : '')}
                    >
                        {parent?.teaserTitle}
                    </label>
                )}
                {teaserText ? (
                    <div className={bem('consent-item-detail-text-wrapper', isLoyaltyItem ? 'hasCheckbox' : '')}>
                        {Parser(teaserText)}
                    </div>
                ) : null}
                {!isLoyaltyItem && !!preTitlePlain?.length && (
                    <Button
                        className={bem('consent-item-detail-button')}
                        type="link"
                        component="a"
                        target="_blank"
                        rel="noopener"
                        onClick={() => this.props.handleOpenEmailInfoOverlay()}
                    >
                        {preTitlePlain}
                    </Button>
                )}
                {children ? children : null}
            </div>
        )
    }
}
